<template>
  <div>
    <div class="loginOverlay"></div>
    <div class="loginText text-center">
      <h2 class="zoomInDown animated3">The Travel Corporation</h2>
      <h2 class="fw-normal zoomInDown animated3">GROUPS</h2>
      <p class="zoomInDown animated4">
        Creating inspiring journeys around the world
      </p>
    </div>
    <agile
      v-if="images && images.length > 0"
      :autoplay="false"
      :dots="false"
      :mobileFirst="true">
      <img
        class="slide"
        v-for="(image, index) in images"
        :key="index"
        :src="`${image}`" />
      <template slot="prevButton">
        <svg class="svg-icon login_icon" viewBox="0 0 20 20">
          <path fill="none" d="M8.388,10.049l4.76-4.873c0.303-0.31,0.297-0.804-0.012-1.105c-0.309-0.304-0.803-0.293-1.105,0.012L6.726,9.516c-0.303,0.31-0.296,0.805,0.012,1.105l5.433,5.307c0.152,0.148,0.35,0.223,0.547,0.223c0.203,0,0.406-0.08,0.559-0.236c0.303-0.309,0.295-0.803-0.012-1.104L8.388,10.049z"></path>
        </svg>
      </template>
      <template slot="nextButton">
        <svg class="svg-icon login_icon" viewBox="0 0 20 20">
          <path fill="none" d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
        </svg>
      </template>
    </agile>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Carousel',
  props: {
    images: {
      type: Array,
      Required: true
    }
  },
  computed: {
    ...mapState(['cdnRack'])
  }
}
</script>
<style>
.agile__slides, .agile__slide {
  width: 100%!important;
  height:100vh;
}
.login_icon path{
    fill:#FFFFFF!important;
}
.login_icon path:hover{
    fill:#b3e4f0!important;
}
.login_icon{
 font-size:3rem;
}
.agile__nav-button {
    width: 55px;
}
</style>
